export default __webpack_public_path__ + "navigation-examples-predictive-caching-thumbnail-960-719d1c2ca9e46a088bd6e41f90831bb8.webp";